import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import { Button, Col } from 'antd'

import { getUnitList, getQCTypeList } from 'features/filter/api'
import {
  UnitFilter,
  GetQCTypeListReq,
  GetUnitListReq,
} from 'features/filter/types'
import {
  selectUnitList,
  selectUnitFilter,
  selectQCTypeList,
} from 'features/filter/selector'
import { clearFilter, updateUnitFilter } from 'features/filter/actions'
import PopupMenu from 'Components/Shared/Filters/PopupMenu'
import QCTypeContent from 'Components/Shared/Filters/QCTypeContent'

import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'

import { getWbsList } from 'features/wbs/wbs.actions'
import { getLeafWbsList } from 'features/wbs/wbs.function'
import { getWbsListSelector } from 'features/wbs/wbs.selector'

import UnitContent from 'Components/Shared/Filters/UnitContent'
import { WbsFilter } from './Components'

type Props = {
  onSearch?: () => void
  ProjectCode: string
  withPadding?: boolean
} & ReduxProps &
  DispatchProps

const UnitFilterPage: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    unitList,
    qctypeList,
    filter,
    onSearch = () => {},
    withPadding = false,
    wbsList,
  } = props

  useEffect(() => {
    dispatch(clearFilter())
    onGetUnitList()
    onGetQCTypeList()
    onGetWbsList()
  }, [ProjectCode, UserEmail])

  const onGetWbsList = () => {
    const req: any = {
      ProjectCode,
      UserEmail,
      Token: token,
    }
    dispatch(getWbsList(req))
  }

  const onGetUnitList = () => {
    const req: GetUnitListReq = {
      ProjectCode,
      UserEmail,
      Zone: 'Resident Area',
    }
    dispatch(getUnitList(token, req))
  }

  const onGetQCTypeList = () => {
    const req: GetQCTypeListReq = {
      UserEmail,
      UnitType: 'Unit',
      Status: 'Active',
    }
    dispatch(getQCTypeList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: UnitFilter) => {
    dispatch(updateUnitFilter(filter))
  }

  const onClick = () => {
    filter.LeafWbsList = getLeafWbsList(wbsList, filter.WbsList)
    dispatch(updateUnitFilter(filter))
    onSearch()
  }

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <div className="filters">
        <Col span={24} className="filters-button">
          <WbsFilter
            onFilterChange={onFilterChange}
            filter={filter}
            wbsList={wbsList}
          />
          <PopupMenu
            label={'ยูนิต'}
            content={
              <UnitContent
                units={unitList.List}
                filter={filter.UnitList}
                onChange={data => {
                  console.log('data', data)
                  filter.UnitList = data
                  onFilterChange(filter)
                }}
              />
            }
            isActive={filter.UnitList.length > 0}
          />
          <PopupMenu
            label={'หมวดงาน QC'}
            content={
              <QCTypeContent
                qctypes={qctypeList.List}
                filter={filter.QCTypeList}
                onChange={data => {
                  filter.QCTypeList = data
                  onFilterChange(filter)
                }}
              />
            }
            isActive={filter.QCTypeList.length > 0}
          />
          <Button type="primary" onClick={onClick}>
            กรองข้อมูล
          </Button>
        </Col>
      </div>
    </MainPage>
  )
}

const MainPage = styled.div`
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const mapStateToProps = (state: RootState) => {
  return {
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectUnitFilter(state),
    unitList: selectUnitList(state),
    qctypeList: selectQCTypeList(state),
    wbsList: getWbsListSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(UnitFilterPage)
